import BaseDataLoadingWrapper from "./BaseDataLoadingWrapper.vue";

export * from "./BaseDataLoadingWrapper.vue";
export default BaseDataLoadingWrapper;
